export const basePath: string = '/'
